import React, { useEffect, useState } from "react";

import { Page, Sidebar, Content, OroLoader } from "../core";

import { Button } from "reactstrap";
import { get, flatten } from "lodash";
import { useHistory, useParams } from "react-router-dom";

import panIcon from "../../src/waitlistDocVault/assets/images/panicon.png";
import panIconMob from "../../src/waitlistDocVault/assets/images/paniconmob.png";

import bankIcon from "../../src/waitlistDocVault/assets/images/bankicon.png";
import bankIconMob from "../../src/waitlistDocVault/assets/images/bankIconMob.png";

import dematIcon from "../../src/waitlistDocVault/assets/images/dematicon.png";
import dematIconMob from "../../src/waitlistDocVault/assets/images/dematIconMob.png";

import adressIcon from "../../src/waitlistDocVault/assets/images/adressicon.png";
import adressIconMob from "../../src/waitlistDocVault/assets/images/adressIconMob.png";



import KycPANContentNew from "./components/KycPANContentNew";
import KycUploadComplete from "./components/KycUploadComplete";
import KycAdressContentNew from "./components/KycAdressContentNew";
import KycBankContent from "../../src/waitlistDocVault/components/KycBankContent";
import KycDematContentNew from "../../src/waitlistDocVault/components/KycDematContentNew";

import {
  getUserPans,
  getThirdPartyData,
  getUploadedDocsList,
  getObUserState
} from "../waitlist/services/waitlist-service";

import success from "../waitlistDocVault/assets/images/success.png";
import failure from "../waitlistDocVault/assets/images/failure.png";
import Verification from "../waitlistDocVault/assets/images/Verification.png";
import KycDocStatus from "./components/KycDocStatus";
import KycPANPreview from "./components/KycPANPreview";
import KycBankPreview from "./components/KycBankPreview";
import KycDematPreview from "./components/KycDematPreview";
import KycAdressPreview from "./components/KycAdressPreview";
import { toast, ToastContainer } from "react-toastify";
import { setAnalyticsEvent } from "../core/helpers/analytics";
import ChooseAddressProof from "./components/ChooseAddressProof";
import PENDING from "../waitlistDocVault/assets/images/pending.png";
import { utils } from "../core/helpers/utils";

const REQ_KYC_DOCS = [
  {
    type: "pan",
    inactiveIcon: panIcon,
    activeIcon: panIconMob,
    desc: "Verify  Details",
  },
  {
    type: "address",
    inactiveIcon: adressIcon,
    activeIcon: adressIconMob,
    desc: "Address Proof",
  },

  {
    type: "bank",
    inactiveIcon: bankIcon,
    activeIcon: bankIconMob,
    desc: "Bank Account",
  },
  {
    type: "demat",
    inactiveIcon: dematIcon,
    activeIcon: dematIconMob,
    desc: "Link Demat",
  },
  // {
  //   type: "confirm",
  //   activeIcon: check,
  //   inactiveIcon: check1,
  //   desc: "Confirm documents",
  // },
];


const addressDocType = [
  'aadhaar',
  'voterId',
  'passport',
  "address",
  "address_1",
  "aadhar",
  "pan",
  "poi"
];

export default function WaitlistDocsUp(props) {
  const history = useHistory();
  const { tab } = useParams();
  const [panValue, setPanValue] = useState("");

  const [uploadedDocs, setUploadedDocs] = useState([]);

  const [isKycDone, setIsKycDone] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [userProfile, setUserProfile] = useState(null);

  const [activeTab, setActiveTab] = useState();

  const [reupload, setReupload] = useState(false);
  const [uploadErrors, setUploadErrors] = useState([]);
  const [docVerifyStatus, setStatus] = useState('pending');
  const [product, setProduct] = useState(props?.product);
  const [productInUrl, setProductInUrl] = useState(null);
  const [isNativeView, setNativeView] = useState(false);
  const [render, setRerender] = useState(false);

  const determinePansError = (rejectRemarks, type) => {
    for (let error of rejectRemarks) {
      if (type === error.type) return true;
    }
    return false;
  }

  const determineDocUploaded = (tpd, docType, docs) => {
    switch (docType) {
      case "pan":
      case "poi":
        return get(tpd, "pan", "") && get(tpd, "dob", "") &&
          get(tpd, "income", "") && get(tpd, "gender", "");
      case "address":
        if (get(tpd, "addressDocType", "") &&
          get(tpd, "addressDetails", "")) {
          return true;
        }
        return false;
      case "demat":
        return get(tpd, "demat", "") ? true : false;
      case "bank":
        if ((get(tpd, "bankVerified.status", "") === 'verified') ||
          (get(tpd, "bankVerified.status", "") === 'verification under process')) {
          return true;
        } else {
          return false;
        }
    }
  }

  const determineActiveTab = () => {
    const errMsg = "Error: Unable to fetch user data";
    let activeDocTab = "pan";
    let docTypes = {
      "pan": 'address',
      "poi": 'address',
      "address": "address",
      "aadhar": "address",
      "address_1": "address",
      "aadhaar": "address",
      "bank": "bank",
      "demat":"demat"
    }
    let tpd;
    let docList = [];
    if (isKycDone) {
      setActiveTab("confirm");
      return;
    }
    return getThirdPartyData({ "X-product": `orobonds:default` })
      .then((result) => {
        const resp = utils.parsePayload(result);
        if (!resp || !resp.success || !resp.data) {
          toast.error(resp.msg || errMsg);
          setActiveTab(activeDocTab);
          return [];
        }
        tpd = resp.data;
        if (!tpd.pan) {
          setActiveTab('pan');
          return [];
        }
        return Promise.all([getUploadedDocsList(
          { payload: utils.encryptedPayload(resp.data.pan) },
          { "X-product": `orobonds:default` }),
        getUserPans({ "X-product": `orobonds:default` })]);
      })
      .then((result) => {
        const [docListResp, panResp] = utils.parsePayload(result);
        if (!docListResp || !panResp) {
          return;
        }
        // if (!docListResp.success) {
        //   setActiveTab(activeDocTab);
        //   return;
        // }
        let docList = docListResp.data;
        if (panResp && panResp.success && panResp.data &&
          panResp.data.length && panResp.data[0].rejectRemarks &&
          panResp.data[0].rejectRemarks.length) {
          for (let type of Object.keys(docTypes)) {
            if (determinePansError(panResp.data[0].rejectRemarks, type)) {
              setReupload(false);
              setActiveTab(docTypes[type]);
              return;
            }
          }
        } else {
          for (let type of ['pan', 'address', 'bank', 'demat']) {
            if (!determineDocUploaded(tpd, type, docList)) {
              setActiveTab(type);
              return;
            }
          }
          setActiveTab('confirm');
          return;
        }
      });
  };

  const moveNextTab = () => {
    let userData = { ...userProfile };
    getThirdPartyData({ "X-product": `orobonds:default`, 'x-encrypted-data': true })
      .then((result) => {
        const thirdPartyData = utils.parsePayload(result);
        if (thirdPartyData && thirdPartyData.success) {
          userData = { ...userData, ...get(thirdPartyData, "data", {}) };

        }
      })
      .finally(() => {
        setUserProfile(userData);
      });
    determineActiveTab();
  };

  const displayTab = (type) => {
    switch (type) {
      case "pan":
        setActiveTab("pan");
        break;
      case "address":
        setActiveTab("address");
        break;
      case "demat":
        setActiveTab("demat");
        break;
      case "bank":
        setActiveTab("bank");
        break;
    }
  }

  const isDocPresent = (docType) => {
    switch (docType) {
      case "pan":
      case "poi":
        return get(userProfile, "pan", "") && get(userProfile, "dob", "") &&
          get(userProfile, "income", "") && get(userProfile, "gender", "");
      case "address":
        if (get(userProfile, "addressDocType", "") &&
          get(userProfile, "addressDetails", "")) {
          return true;
        }
        return false;
      case "demat":
        return get(userProfile, "demat", "") ? true : false;
      case "bank":
        if ((get(userProfile, "bankVerified.status", "") === 'verified') ||
          (get(userProfile, "bankVerified.status", "") === 'verification under process')) {
          return true;
        } else {
          return false;
        }
    }
  };

  const areAllDocsUploaded = async (docs) => {
    let allDocsUploaded = true;
    await setUploadedDocs(docs);

    ["pan", "address", "bank", "demat"].forEach((docType) => {
      allDocsUploaded = allDocsUploaded && isDocPresent(docType);
    });
  };

  const checkAllDocsUploaded = () => {
    let ifAllDocPresent = true;
    ["pan", "address", "bank", "demat"].forEach(doc => {
      if (!isDocPresent(doc)) {
        ifAllDocPresent = false;
        return ifAllDocPresent;
      }
    });
    return ifAllDocPresent;
  }

  const updateDocStatus = () => {
    let panErrors = [];
    getThirdPartyData({ "X-product": `orobonds:default` }).then(
      async (result) => {
        const tpdResp = utils.parsePayload(result);
        if (!tpdResp || !tpdResp.success) {
          return toast.error(tpdResp.msg || "Error: Couldn't fetch user Details.");
        }
        await setUserProfile({ ...get(tpdResp, "data", {}) });
        getUserPans({ "X-product": `orobonds:default` }).then(
          async (result) => {
            const response = utils.parsePayload(result);
            if (response && response.success) {
              panErrors = [...flatten(
                get(response, "data", []).map((p) =>
                  p.rejectRemarks ? p.rejectRemarks : []
                )
              )]
              await setUploadErrors(panErrors);
            } else {
              return toast.error("Error: Unable to fetch user details.");
            }
          }
        );
      }
    );
  }

  const getStateName = (index) => {
    switch (index) {
      case 0:
        return "Verify Details";
      case 1:
        return "Address Proof";
      case 2:
        return "Bank Account";
      case 3:
        return "Link Demat";
    }
  }

  const SideBarComponent = (input) => {
    const checkVerification = () => {
      if (isKycDone) {
        setStatus('verified');
        return (
          <div className="main_div_img">
            <div>
              <img src={success} alt="success-icon"/>
            </div>
            {
              props.isMobile &&
              <div className="main_div_content">
                <p className="font-size-tiny mt-2">{getStateName(input?.index)}</p>
              </div>
            }
          </div>
        );
      }
      if (isDocPresent(input.type)) {
        if (input.type === "pan") {
          return (
            <>
              <img src={success} alt="success-icon"/>
              {
                props.isMobile &&
                <>
                  <p className="font-size-tiny mt-2">{getStateName(input?.index)}</p>
                </>
              }
            </>
          );
        } else if (input.type !== "address") {
          if (uploadErrors && uploadErrors.filter(e => e.type === input.type).length) {
            setStatus('failed');
            return (
              <>
                <img src={failure} alt="failure-icon"/>
                {
                  props.isMobile &&
                  <>
                    <p className="font-size-tiny mt-2">{getStateName(input?.index)}</p>
                  </>
                }
              </>
            );
          } else {
            return (
              <>
                <img src={success} alt="success-icon"/>
                {
                  props.isMobile &&
                  <>
                    <p className="font-size-tiny mt-2">{getStateName(input?.index)}</p>
                  </>
                }
              </>
            );
          }
        } else {
          if (uploadErrors &&
            uploadErrors.find(e => addressDocType.includes(e.type))
            && uploadErrors.find(e => addressDocType.includes(e.type)).remarks) {
            setStatus('failed');
            return (
              <>
                <img src={PENDING} alt="pending-icon"/>
                {
                  props.isMobile &&
                  <>
                    <p className="font-size-tiny mt-2">{getStateName(input?.index)}</p>
                  </>
                }
              </>
            );
          } else {
            return (
              <>
                <img src={success} alt="success-icon"/>
                {
                  props.isMobile &&
                  <>
                    <p className="font-size-tiny mt-2">{getStateName(input?.index)}</p>
                  </>
                }
              </>
            );
          }
        }
      }
      setStatus('failed');
      return (
        <>
          <img src={PENDING} alt="pending-icon"/>
          {
            props.isMobile &&
            <>
              <p className="font-size-tiny mt-2">{getStateName(input?.index)}</p>
            </>
          }
        </>
      );
    }
    return !props.isMobile ? (<div className="circle-btn">
      <div Name="outer">
        <div className="inner">
          {checkVerification()}
        </div>
      </div>
      <div
        /**May require in future */
        // onClick={() => {
        //   setReupload(false);
        //   setActiveTab(input.type);
        // }}
        className={
          activeTab === input.type
            ? "kyc-button-focus d-flex"
            : "kyc-button d-flex"
        }
      >
        <div className="kyc-icon">
          {activeTab === input.type ? (
            <img src={input.activeIcon} alt="active-icon"/>
          ) : (
            <img src={input.inactiveIcon} alt="inactive-icon"/>
          )}
        </div>

        <div className="kyc-step">
          <b className="text-capitalize">{input.desc}</b>
        </div>
      </div>
    </div>) : (
      <div>
        <div className="outer-mobile"
        /**May require in future */
        // onClick={() => {
        //   setReupload(false);
        //   setActiveTab(input.type);
        // }}
        >
          <div className="inner-mobile">
            {/* {isDocPresent(input.type) ? (
                  <img src={success}></img>
                ) : (
                  <img src={failure}></img>
                )} */}
            {checkVerification()}
          </div>
        </div>
        {/* {activeTab === input.type && <div className="kyc-step-mob d-flex">
              <div className="step-icon-mob">
                <span>
                  <img src={input.activeIcon} />
                </span>
              </div>
              <div className="btn-text">
                <h5>
                  <strong>{input.desc}</strong>{" "}
                </h5>
              </div>
            </div>} */}
      </div>
    )
  };

  const SideBarComponentMob = (input) => {
    return activeTab === input.type &&
      (<div className="kyc-step-mob d-flex">
        {/* <div className="step-icon-mob">
          <span>
            <img src={input.activeIcon} />
          </span>
        </div>
        <div className="btn-text">
          <h5>
            <strong className="text-capitalize">{input.desc}</strong>{" "}
          </h5>
        </div> */}
      </div>)
  }

  const getAllUserData = () => {
    getUserPans({ "X-product": `orobonds:default` })
      .then((result) => {
        const pansData = utils.parsePayload(result);
        if (pansData && pansData.success) {
          setUploadErrors(
            [...flatten(
              get(pansData, "data", []).map((p) =>
                p.rejectRemarks ? p.rejectRemarks : []
              )
            )]
          );
          let userData = get(pansData, "data.0", {});

          if (props.thirdpartyData) {
            userData = { ...userData, ...get(props.thirdpartyData, "data", {}) };
          }
          setUserProfile(userData);

          if (get(userData, "pan", "")) {
            getUploadedDocsList(
              { payload: utils.encryptedPayload(get(userData, "pan", "")) },
              { "X-product": `orobonds:default` }
            ).then((result) => {
              const docsList = utils.parsePayload(result);
              if (docsList && docsList.success) {
                setUploadedDocs(get(docsList, "data", []));
                areAllDocsUploaded(get(docsList, "data", []));
              }
            });
          }
        }
      })
      .finally(() => {
        setTimeout(() => {
          setShowLoader(false);
        }, 500);
      });
  };

  const getTabFromUrl = () => {
    if (!tab) {
      setActiveTab('pan');
    } else {
      setActiveTab(tab);
    }
  }

  const getUpdatedPreviewDocs = () => {
    getUploadedDocsList(
      { payload: utils.encryptedPayload(get(userProfile, "pan", "")) },
      { "X-product": `orobonds:default` }
    ).then((result) => {
      const docsList = utils.parsePayload(result);
      if (docsList && docsList.success) {
        setUploadedDocs(get(docsList, "data", []));
        areAllDocsUploaded(get(docsList, "data", []));
        console.log(
          "Uploaded Docs:",
          get(docsList, "data", []).map((doc) => doc.type)
        );
      }
    });
  }

  const reload = () => {
    setRerender(true)
  };

  useEffect(() => {
    setProductInUrl(props.locationState && props.locationState.product);
    if (props.locationState &&
      props.locationState.obUserApproved) { //the state that has been sent though location is accessed here
      setIsKycDone(true);
    } else {
      let email = userProfile && userProfile.email ?
        userProfile.email :
        get(props.thirdpartyData, 'data.email', '');
      let pan = userProfile && userProfile.pan ?
        userProfile.pan :
        get(props.thirdpartyData, 'data.pan', '');
      getObUserState(
        { email, pan },
        product,
        { "X-product": `orobonds:default` }
      ).then(
        (result) => {
          const obState = utils.parsePayload(result);
          if (obState && obState.success) {
            setIsKycDone(obState.results.obUserApproved);
          }
        }
      )
    }
  }, [props.locationState, render])

  useEffect(() => {
    determineActiveTab();
    if (isKycDone &&
      (!props.locationState ||
        (props.locationState &&
          !props.locationState.tab))) {
      setActiveTab("confirm");
    }
  }, [isKycDone])

  useEffect(() => {
    if (window.ReactNativeWebView) {
      setNativeView(true);
    }
    getAllUserData();
    getTabFromUrl();
    determineActiveTab();
    if (props.locationState && props.locationState.tab === "demat") {
      setReupload(false);
      setActiveTab("demat");
    }
    else if (isKycDone &&
      props.locationState &&
      !props.locationState.tab) {
      setActiveTab("confirm");
    } else {
      setActiveTab('pan');
    }
  }, []);

  const updatePanValue = (val) => {
    setPanValue(val)
  }

  const getConfirmTabStatus = () => {
    if (docVerifyStatus === 'verified' || isKycDone) {
      return <img src={success} alt="success-icon"/>;
    } else if (checkAllDocsUploaded() && !uploadErrors.length) {
      return <img src={Verification} alt="success-icon"/>;
    } else {
      return <img src={failure} alt="failure-icon"/>;
    }
  }

  const backBtnAction = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ action: "GO_BACK", data: "dashboard" })
      );
    } else {
      history.replace('/biddeasy-dashboard');
    }
  }

  return (
    <Page className={isNativeView ? "main-div pt-0 pb-0" : "main-div"}>
      {showLoader ? (
        <OroLoader />
      ) : (
        <>
          <Sidebar
            className="pl-4 p-4 pt-5 ml-0 bg-secondary text-white"
            style={props.isMobile ? { height: 'fit-content' } : {}}
            md="4"
          >
            {/* <div className="back-btn">
              <Button className="backbtn" 
                      onClick={() => {
                        history.replace("/waitlist");
                      }}
              >
                <span class="mdi mdi-arrow-left-thick"></span>
              </Button>
            </div> */}
            <p className={!isNativeView ? "back-btn" : "d-none back-btn"}>
              <span
                onClick={backBtnAction}
                className="mdi mdi-arrow-left"
              />
            </p>

            <div
              className={!isNativeView ?
                "font-weight-semi-bold font-size-double text-center" :
                "d-none"}
              data-testid="title"
            >
              Complete KYC
            </div>
            <br />
            <div className={"waitlist-kyc-menu " + (props.isMobile ? "d-flex flex-row justify-content-between" : "")}>
              {REQ_KYC_DOCS.map((DOC, i) => (
                <>
                  <SideBarComponent key={i} index={i} {...DOC} />
                  {props.isMobile && (i + 1) < REQ_KYC_DOCS.length ? (
                    <div className="separator-mob" />
                  ) : null}
                </>
              ))}
              {/* <div className="circle-btn"> */}
              {/* <div 
                className={props.isMobile ? "" : "circle-btn"}
              >
                <div className={!props.isMobile ? "outer" : "outer-mobile"}>
                  <div className={!props.isMobile ? "inner" : "inner-mobile"}>
                  {getConfirmTabStatus()}
                  </div>
                  {!props.isMobile ?
                    <div
                      className={
                        activeTab == 'confirm'
                          ? "kyc-button-focus d-flex"
                          : "kyc-button d-flex"
                      }
                    >
                      <div className="kyc-icon">
                        {activeTab == 'confirm' ? (
                          <img src={check} />
                        ) : (
                          <img src={check1} />
                        )}
                      </div>

                      <div className="kyc-step text-capitalize">
                        <b>Confirm documents</b>
                      </div>
                    </div> : null}
                </div>
              </div> 
              : null}
              </div>               */}
            </div>
            <>
              {/* {REQ_KYC_DOCS.map((DOC, i) => (
                <>
                  {props.isMobile && <SideBarComponentMob key={i} index={i} {...DOC} />}
                </>
              ))} */}
              {/* {props.isMobile ? (activeTab === 'confirm' && 
              <div className="kyc-step-mob d-flex">
                <div className="step-icon-mob">
                  <span>
                    <img src={check} />
                  </span>
                </div>
                <div className="btn-text">
                  <h5>
                    <strong className="text-capitalize">Confirm documents</strong>{" "}
                  </h5>
                </div>
              </div>) : null} */}
            </>
          {/* </div> */}
        </Sidebar>

      <Content className="kyc-menu-content">
        <div className="main-container">
          {activeTab === "pan" &&
            (isDocPresent("pan") && !reupload ? (
              <KycPANPreview
                setReupload={setReupload}
                userProfile={userProfile}
                errors={uploadErrors.filter((e) => e.type === "pan" || e.type === "poi")}
                isKycDone={isKycDone}
                panValue={panValue || (userProfile && userProfile.pan)}
                moveNextTab={moveNextTab}
                product={product}
              />
            ) : (
              <KycPANContentNew
                email={props.email}
                moveNextTab={moveNextTab}
                setReupload={setReupload}
                passBackPanValue={updatePanValue}
                areAllDocsUploaded={areAllDocsUploaded}
                updateDocStatus={updateDocStatus}
                uploadedDocs={uploadedDocs}
                product={product}
                userProfile={userProfile}
              />
            ))}

          {activeTab === "address" &&
            (isDocPresent("address")
              && !reupload ? (
              <KycAdressPreview
                setReupload={setReupload}
                errors={uploadErrors.filter(e => addressDocType.includes(e.type))}
                docs={uploadedDocs.filter(
                  (d) => d.type === "pan" || d.type === "poi" ||
                    d.type === "address" || d.type === "address_1"
                )}
                isKycDone={isKycDone}
                userProfile={userProfile}
                moveNextTab={moveNextTab}
                product={product}
                uploadedDocs={uploadedDocs}
              />
            ) : (
              <ChooseAddressProof
                product={product}
                pan={panValue}
                email={props.email}
                setReupload={setReupload}
                moveNextTab={moveNextTab}
                areAllDocsUploaded={areAllDocsUploaded}
                userProfile={userProfile}
                thirdpartyData={props.thirdpartyData}
                updateDocStatus={updateDocStatus}
                uploadedDocs={uploadedDocs}
                errors={uploadErrors.filter(e => addressDocType.includes(e.type))}
              />
            ))}

          {activeTab === "bank" &&
            (isDocPresent("bank") && !reupload ? (
              <KycBankPreview
                panValue={panValue}
                email={props.email}
                setReupload={setReupload}
                errors={uploadErrors.filter((e) => e.type === "bank")}
                isKycDone={isKycDone}
                userProfile={userProfile}
                moveNextTab={moveNextTab}
                areAllDocsUploaded={areAllDocsUploaded}
                updateDocStatus={updateDocStatus}
                docs={uploadedDocs.filter(
                  (d) => d.type === "bank"
                )}
                product={product}
              />

            ) : (
              <KycBankContent
                panValue={panValue}
                email={props.email}
                isKycDone={isKycDone}
                moveNextTab={moveNextTab}
                setReupload={setReupload}
                from={props.locationState && props.locationState.from}
                areAllDocsUploaded={areAllDocsUploaded}
                userProfile={userProfile}
                thirdpartyData={props.thirdpartyData}
                updateDocStatus={updateDocStatus}
                product={product}
              />
            ))}

          {activeTab === "demat" &&
            (isDocPresent("demat") && !reupload ? (
              <KycDematPreview
                setReupload={setReupload}
                errors={uploadErrors.filter((e) => e.type === "demat")}
                isKycDone={isKycDone}
                userProfile={userProfile}
                moveNextTab={moveNextTab}
                product={product}
                email={props.email}
              />
            ) : (
              <KycDematContentNew
                setReupload={setReupload}
                panValue={panValue}
                email={props.email}
                isKycDone={isKycDone}
                moveNextTab={moveNextTab}
                from={props.locationState && props.locationState.from}
                areAllDocsUploaded={areAllDocsUploaded}
                updateDocStatus={updateDocStatus}
                product={product}
                errors={uploadErrors.filter((e) => e.type === "demat")}
                locationState={props.locationState}
                userProfile={userProfile}
              />
            ))}


          {/* {
                activeTab == "complete" && (
                <KycUploadComplete
                  panValue={panValue}
                  email={props.email}
                  isKycDone={isKycDone}
                  areAllDocsUploaded={areAllDocsUploaded}
                  product={product}
                />
              )} */}

          {activeTab === "confirm" && (
            <KycDocStatus
              thirdPartyData={userProfile}
              displayTab={displayTab}
              errors={uploadErrors}
              isKycDone={isKycDone}
              isDocPresent={isDocPresent}
              product={productInUrl}
              setReupload={setReupload}
              email={props.email}
              reload={reload}
            />
          )}
        </div>
      </Content>
    </>
  )
}
<ToastContainer />
    </Page >
  );
}
